import './liquidcali/style';
import FormStructure from './liquidcali/form_structure';

export default FormStructure;